export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70 pt-14 md:pt-16 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-lg text-background-50"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">吃瓜官网</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              专业娱乐资讯与八卦爆料聚合平台。提供51吃瓜官网首页进入、吃瓜网站最新地址及51吃瓜官方入口，安全直达吃瓜平台首页，畅享八卦爆料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '热门话题', href: '#topics' },
                { label: '热度榜单', href: '#ranking' },
                { label: '平台特色', href: '#features' },
                { label: '关于我们', href: '#about' },
                { label: '专题索引', href: '#index' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">内容频道</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">明星恋情追踪</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">综艺幕后揭秘</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">影视深度吐槽</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">饭圈动态速递</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">每周吃瓜总结</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              期待与更多优质平台合作，共同打造健康有益的娱乐资讯生态。
            </p>
            <div className="mt-4">
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
                className="inline-block px-4 py-2 bg-primary-500/80 text-background-50 text-sm font-medium rounded-full hover:bg-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                合作联系
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 吃瓜官网 51吃瓜官方入口. All rights reserved.
          </p>
          <p className="text-xs text-background-50/30">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}